export default __webpack_public_path__ + "img/mask.faafc003.svg";